import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default from 'react';

var _excluded = ["as", "children", "className", "clickable", "align", "direction", "disabled", "justify", "onClick", "noWrap"];
var TableRow = function TableRow(props, context) {
  var _props$as = props.as,
    As = _props$as === void 0 ? 'tr' : _props$as,
    children = props.children,
    className = props.className,
    clickable = props.clickable,
    align = props.align,
    direction = props.direction,
    disabled = props.disabled,
    justify = props.justify,
    onClick = props.onClick,
    _props$noWrap = props.noWrap,
    noWrap = _props$noWrap === void 0 ? true : _props$noWrap,
    otherProps = _objectWithoutProperties(props, _excluded);
  var handleRowSelect = function handleRowSelect(event) {
    if (event.type === 'click') {
      // if a click, submit click event
      onClick && onClick(event);
    } else if (event.key === ' ') {
      // if a key, only submit click event on spacebar
      event.preventDefault(); // prevents spacebar from scrolling the page
      onClick && onClick(event);
    }
  };
  var finalClasses = classnames('C-TableRow', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "--align-".concat(align), align), '--clickable', clickable || onClick), '--disabled', disabled), "--direction-".concat(direction), direction), "--justify-".concat(justify), justify), '--no-wrap', noWrap), className);
  var genChildren = function genChildren(child, index) {
    if (child && child.type && child.type.displayName) {
      // if this is the first child in a row, give it extra props for screen readers
      if (index === 0 && child.type.displayName !== 'Table.Header') {
        return /*#__PURE__*/React__default.cloneElement(child, {
          'data-column-index': index,
          role: 'rowheader',
          scope: 'row'
        });
      }
      // if this is a column header, generate it an index so when we sort, we know which column index is being sorted
      if (child.type.displayName === 'Table.Header') {
        return /*#__PURE__*/React__default.cloneElement(child, {
          'data-column-index': index
        });
      }
    }
    return child;
  };
  var generatedChildren;
  if (children && children.length) {
    // more than one child exists in array
    generatedChildren = children.map(genChildren);
  } else {
    // one child exists as an object
    generatedChildren = genChildren(children, 0);
  }
  if (!disabled && clickable || !disabled && onClick) {
    return /*#__PURE__*/React__default.createElement(As, _extends({
      onClick: handleRowSelect,
      onKeyDown: handleRowSelect,
      tabIndex: disabled ? '-1' : '0',
      className: finalClasses,
      "aria-label": disabled ? "disabled row" : "select this row"
    }, otherProps), generatedChildren);
  } else {
    return /*#__PURE__*/React__default.createElement(As, _extends({
      className: finalClasses
    }, otherProps), generatedChildren);
  }
};
TableRow.displayName = 'Table.Row';

export { TableRow as default };
